export default __webpack_public_path__ + "static/media/SVG-subcribe2.ed676656.png";